module.exports = new __parcel__URL__("shop_machines_little_lemon_tree.d0840e6c.png").toString();